import { useEffect, useState } from "react";
import { useFetchGetData } from "./useFetchData";
import { useQueryParams } from "./useLocationData";
import searchMapping from "../data/mapping/components/searchMapping";
import globalMockData from "../data/components/global-data.json";
import { useLanguage } from "./useLanguage";

const useSearchData = (searchConfig) => {
  const queryKey = "searchData";
  let language = useLanguage();
  const queryParams = useQueryParams();
  const searchText = queryParams.get(searchConfig.title.toLowerCase())

  const queryPath = `/jsonapi/index/database_index?filter[fulltext]=${searchText}`;

  const isMockData = queryParams.get("useMockData") === "true";

  const [searchData, setSearchData] = useState("");

  const { isLoading, error, data, refetch } = useFetchGetData(
    queryKey,
    queryPath,
    isMockData
  );

  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = searchMapping(data);
      setSearchData(mappedData);
    }
  }, [data, isMockData]);

  useEffect(() => {
    refetch()
  }, [ language, searchText, refetch ]);

  if (isMockData) {
    return { error: false, isLoading: false, searchData: globalMockData };
  }

  return { error, isLoading, searchData };
};

export default useSearchData;
